import React from "react";

/** Pixelated Mario-style coin with a "V" in the center (V-coin currency icon). */
export default function MarketplaceCoinIcon({ size = 22, className = "" }) {
  return (
    <svg
      className={`pb-marketplace-coin${className ? ` ${className}` : ""}`}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      shapeRendering="crispEdges"
      aria-hidden="true"
      focusable="false"
    >
      {/* outer rim */}
      <rect x="5" y="1" width="6" height="1" fill="#b45309" />
      <rect x="3" y="2" width="2" height="1" fill="#b45309" />
      <rect x="11" y="2" width="2" height="1" fill="#b45309" />
      <rect x="2" y="3" width="1" height="2" fill="#b45309" />
      <rect x="13" y="3" width="1" height="2" fill="#b45309" />
      <rect x="1" y="5" width="1" height="6" fill="#b45309" />
      <rect x="14" y="5" width="1" height="6" fill="#b45309" />
      <rect x="2" y="11" width="1" height="2" fill="#b45309" />
      <rect x="13" y="11" width="1" height="2" fill="#b45309" />
      <rect x="3" y="13" width="2" height="1" fill="#b45309" />
      <rect x="11" y="13" width="2" height="1" fill="#b45309" />
      <rect x="5" y="14" width="6" height="1" fill="#b45309" />
      {/* gold face */}
      <rect x="5" y="2" width="6" height="1" fill="#fde047" />
      <rect x="3" y="3" width="10" height="1" fill="#fde047" />
      <rect x="3" y="4" width="10" height="8" fill="#facc15" />
      <rect x="4" y="12" width="8" height="1" fill="#fde047" />
      <rect x="5" y="13" width="6" height="1" fill="#fde047" />
      {/* highlight */}
      <rect x="4" y="3" width="3" height="2" fill="#fef9c3" />
      <rect x="4" y="5" width="1" height="3" fill="#fef9c3" />
      {/* shadow */}
      <rect x="10" y="10" width="2" height="2" fill="#ca8a04" />
      <rect x="8" y="11" width="2" height="1" fill="#ca8a04" />
      {/* V letter */}
      <rect x="5" y="5" width="1" height="4" fill="#78350f" />
      <rect x="10" y="5" width="1" height="4" fill="#78350f" />
      <rect x="6" y="9" width="1" height="1" fill="#78350f" />
      <rect x="9" y="9" width="1" height="1" fill="#78350f" />
      <rect x="7" y="10" width="2" height="1" fill="#78350f" />
    </svg>
  );
}
